<template>
  <v-dialog v-model="dialog" eager max-width="1000px">
    <v-card class="auditoria">
      <v-card-title>
        <span class="text-h5">{{ $t("view.auditoria.main.titulo.label") }}</span>
        <v-spacer />
        <span class="text-h5 mr-6 hidden-sm-and-down">{{ $t("view.commons.clave") + ": " + clave }}</span>
        <v-btn v-if="backVisible" fab small color="primary" class="btn_tippy mr-3" elevation="0" :title="$t('view.commons.back')" @click="back()">
          <v-icon small>fas fa-arrow-left</v-icon>
        </v-btn>
        <v-btn fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.close')" @click="close()">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        <v-layout row wrap class="mx-0" :class="backVisible ? 'pr-32' : 'pr-16'">
          <v-flex md3>{{ $t("view.auditoria.main.titulo.label") + " / " + title }}</v-flex>
          <v-flex xs12 class="hidden-md-and-up" md3>{{ $t("view.commons.clave") + clave }}</v-flex>
          <v-flex md9 class="text-md-right">{{ $t("view.auditoria.main.descripcion.label") + ": " + descripcion }}</v-flex>
        </v-layout>
      </v-card-subtitle>
      <v-card-text>
        <auditoria-main-table v-show="section.main.visible" ref="AuditoriaMainTable" @detail="detail" />
        <auditoria-detail-table v-show="section.detail.visible" ref="AuditoriaDetailTable" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import AuditoriaMainTable from "@/components/auditoria/AuditoriaMainTable"; /** *******************************/
import AuditoriaDetailTable from "@/components/auditoria/AuditoriaDetailTable"; /** *******************************/
import tippy from "tippy.js";

export default {
  name: "AuditoriaModal"
  , components: { AuditoriaMainTable, AuditoriaDetailTable }
  , data() {
    return {
      dialog: false
      , clave: ""
      , title: ""
      , tabla: ""
      , descripcion: ""
      , main: true
      , section: {
        main: { visible: true }
        , detail: { visible: false }
      }
    };
  }
  , computed: {
    backVisible() {
      return this.section.detail.visible && this.main;
    }
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    async loadAudit(clave, tabla, descripcion, title) {
      let that = this;
      Object.keys(this.section).forEach(function (key) {
        that.section[key].visible = false;
      });

      this.main = true;
      this.clave = clave;
      this.title = title;
      this.tabla = tabla;
      this.descripcion = descripcion;

      await this.back();
      this.dialog = true;
    }
    , async loadAuditDetail(clave, tabla, descripcion, title, revision) {
      let that = this;
      Object.keys(this.section).forEach(function (key) {
        that.section[key].visible = false;
      });

      this.main = false;
      this.clave = clave;
      this.title = title;
      this.tabla = tabla;
      this.descripcion = descripcion;

      this.detail(revision);
      this.dialog = true;
    }
    , async back() {
      this.section.detail.visible = false;
      this.section.main.visible = true;
      await this.$refs.AuditoriaDetailTable.back();
      setTimeout(() => document.body.click(), 100);
      await this.$refs.AuditoriaMainTable.loadChanges(this.clave, this.tabla, this.descripcion);
    }
    , async close() {
      this.section.detail.visible = false;
      this.section.main.visible = true;
      this.dialog = false;
    }
    , async detail(revision) {
      await this.$refs.AuditoriaDetailTable.loadRevision(this.clave, this.tabla, this.descripcion, revision);
      this.section.detail.visible = true;
      this.section.main.visible = false;
    }
  }
};
</script>

<style>
.v-application .pr-32 {
  padding-right: 115px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/auditoria/Auditoria.vue